/**
 * Check si une chaine de caractère est un nombre correcte
 * @param value - string - Chaine à tester
 */
export const checkIsValidNumber = (value: string): boolean => {
  const regex = /^\d*[.,]?\d+?$/;

  return !!(value && value.match(regex));
};
